import { ChangeDetectorRef, Component } from "@angular/core";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { SuperClassComponent } from "@sharedV11/super-class-edit/super-class/super-class.component";
import { EditCentroCosteTxComponent } from "./edit-centro-coste-tx/edit-centro-coste-tx.component";

@Component({
  selector: "app-centro-coste-tx",
  templateUrl: "./centro-coste-tx.component.html",
  styleUrls: ["./centro-coste-tx.component.scss"],
})
export class CentroCosteTxComponent extends SuperClassComponent {
  constructor(
    protected panelService: PanelService,
    protected cdRef: ChangeDetectorRef
  ) {
    super(panelService, cdRef);
  }

  openPanel() {
    this.customanpanel = EditCentroCosteTxComponent;
    this.editChangeCss();
    this.cdRef.detectChanges();
  }
}
